import '@fontsource-variable/montserrat';

// Core
import './core/gsap.js';

// Utils
import './utils/dom.js';

// Composants
import './components/header.js';
import './components/plyr.js';
import './components/swiper.js';
import './components/nav.js';
import './components/parallax.js';
import './components/video-dialog.js';
import './components/load-more.js';
import './components/form.js';
import './components/menu-lang.js';

// Animations spécifiques
import './animations/loader.js';
